// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"db9a5f77","903":"61bf6431"}[chunkId] + ".chunk.js";
};